<template>
  <div id="page">
    <div class="row topCardGrid" id="cards">
      <sp-card :valor="cards.total_admissao" :sufix="$t('funcionalismo.historico-servidores.cards.admissao.sufixo')"
        :footerText="$t('funcionalismo.historico-servidores.cards.admissao.rodape', {ano : cards.ano})">
      </sp-card>
      <sp-card :valor="cards.total_aposentadoria" :sufix="$t('funcionalismo.historico-servidores.cards.aposentadoria.sufixo')"
        :footerText="$t('funcionalismo.historico-servidores.cards.aposentadoria.rodape', {ano : cards.ano})">
      </sp-card>
      <sp-card :valor="cards.total_vacancia" :sufix="$t('funcionalismo.historico-servidores.cards.vacancia.sufixo')"
        :footerText="$t('funcionalismo.historico-servidores.cards.vacancia.rodape', {ano : cards.ano})">
      </sp-card>
    </div>
    <div class="row">
      <div class="flex col md12 sm12">
        <sp-360-panel :title="$t('funcionalismo.historico-servidores.graficos.barras-amostragem.titulo', {corte: valueAdmAposentVacOrdenacaoCaracteristica, orgao: valueAdmAposentVacSecretariaCaracteristica, ano : valueAdmAposentVacDataCaracteristica})"
         :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})" :footerCompementar="$t('funcionalismo.historico-servidores.graficos.barras-amostragem.rodape')">

          <div class="row">
            <div class="flex md4 sm12">
              <multiselect v-model="valueAdmAposentVacOrdenacaoCaracteristica"
                :options="listaTipoOrdenacao"
                :placeholder="$t('funcionalismo.historico-servidores.graficos.barras-amostragem.filtro.corte')"
                @input="multiselectAdmAposentVacOrdenacaoCaracteristica"
                :allow-empty="false"/>
            </div>
            <div class="flex md4 sm12">
              <multiselect v-model="valueAdmAposentVacSecretariaCaracteristica"
                :options="listaOrgaos"
                :placeholder="$t('funcionalismo.historico-servidores.graficos.barras-amostragem.filtro.orgao')"
                @input="multiselectAdmAposentVacSecretariaCaracteristica"
                :allow-empty="false"/>
            </div>
            <div class="flex md4 sm12">
              <multiselect v-model="valueAdmAposentVacDataCaracteristica"
                :options="listaDataFiltro"
                :placeholder="$t('funcionalismo.historico-servidores.graficos.barras-amostragem.filtro.data')"
                @input="multiselectAdmAposentVacDataCaracteristica"
                :allow-empty="false"/>
            </div>
          </div>

          <div class="row">
            <div class="flex col md6 sm12">
              <sp360-chart id="faixaEtaria" type="horizontal-bar" :data="faixaEtaria.data" :options="faixaEtaria.options" />
            </div>
            <div class="flex col md6 sm12">
              <sp360-chart id="racaSexo" type="vertical-bar" :data="racaSexo.data" :options="racaSexo.options" />
            </div>
          </div>
        </sp-360-panel>
      </div>
      <div class="flex col md12 sm12">
        <sp-360-panel :title="$t('funcionalismo.historico-servidores.graficos.linha-historico.titulo')"
        :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})" :footerCompementar="$t('funcionalismo.historico-servidores.graficos.linha-historico.rodape')">
          <sp360-chart id="historicoAdmissaoAposentadoriaVac" type="line" :data="historicoAdmVac.data" :options="historicoAdmVac.options" />
        </sp-360-panel>
      </div>
      <div class="flex col md12 sm12">
        <sp-360-panel :title="$t('funcionalismo.historico-servidores.graficos.linha-historico-raca.titulo',{corte: valueAdmVacLinhaHistoricoRaca})"
        :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})" :footerCompementar="$t('funcionalismo.historico-servidores.graficos.linha-historico-raca.rodape')">
          <div class="row">
            <div class="flex md6 sm12">
              <multiselect v-model="valueAdmVacLinhaHistoricoRaca"
                    :options="listaTipoOrdenacao"
                    :placeholder="$t('funcionalismo.historico-servidores.graficos.barras-amostragem.filtro.corte')"
                    @input="multiselectAdmVacHistoricoRaca"
                    :allow-empty="false"/>
            </div>
            <div class="flex md6 sm12">
              <multiselect v-model="valueAdmVacLinhaHistoricoRacaSexo"
                    :options="listaTipoSexo"
                    :placeholder="$t('funcionalismo.historico-servidores.graficos.linha-historico-raca.filtro.sexo')"
                    @input="multiselectAdmVacHistoricoRacaSexo"
                    :allow-empty="false"/>
            </div>
          </div>
          <sp360-chart id="historicoAdmissaoAposentadoriaVacHistRaca" type="line" :data="historicoAdmVacRaca.data" :options="historicoAdmVacRaca.options" />
        </sp-360-panel>
      </div>
      <div class="flex col md12 sm12">
        <sp-360-panel :title="$t('funcionalismo.historico-servidores.graficos.barra-comparativo-orgao.titulo', {ordenacao: valueAdmAposentVacOrdenacao, ano: valueAdmAposentVacData})"
        :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})" :footerCompementar="$t('funcionalismo.historico-servidores.graficos.barra-comparativo-orgao.rodape')">
          <div class="row">
            <div class="flex md6 sm12">
              <multiselect v-model="valueAdmAposentVacOrdenacao"
                :options="listaTipoOrdenacao"
                :placeholder="$t('funcionalismo.historico-servidores.graficos.barra-comparativo-orgao.filtro.ordenacao')"
                @input="multiselectAdmAPosentVacOrdenacao"
                :allow-empty="false"/>
            </div>
            <div class="flex md6 sm12">
              <multiselect v-model="valueAdmAposentVacData"
                :options="listaDataFiltro"
                :placeholder="$t('funcionalismo.historico-servidores.graficos.barra-comparativo-orgao.filtro.data')"
                @input="multiselectAdmAposentVacData"
                :allow-empty="false"/>
            </div>
          </div>
          <sp360-chart id="admissaoAPosentadoriaVac" type="vertical-bar" :data="admVacAposent.data" :options="admVacAposent.options" />
        </sp-360-panel>
      </div>
    </div>
  </div>
</template>

<script>
import CorUtils from '@/utils/CorUtils'
import MethGlob from '@/utils/MetodosGlobais'
import Constantes from '@/utils/ConstantesGlobais'
import Multiselect from 'vue-multiselect'
import _ from 'lodash'
import Overlay from '@/assets/geojson/spoverlay'
import SpCard from '@/components/ui/cards/SP360Card'
import { gmapApi } from 'vue2-google-maps'
import * as d3 from 'd3'
import * as legend from 'd3-svg-legend'
import ChartAnnotation from 'chartjs-plugin-annotation'
import Sp360Chart from '@/components/ui/chart/sp360chart'
import Sp360List from '@/components/ui/list/VaList'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'
import Sp360DataTable from '@/components/ui/dataTable/sp360datatable'
import Legenda from '@/components/maps/360-maps/Legenda'

import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import * as am4plugins_forceDirected from '@amcharts/amcharts4/plugins/forceDirected'
import am4themes_animated from '@amcharts/amcharts4/themes/animated'
import { order } from '@amcharts/amcharts4/.internal/core/utils/Number'

export default {
  name: 'historico-servidores',
  mixins: [Overlay, Legenda],
  components: {
    SpCard,
    Multiselect,
    Sp360Chart,
    Sp360Panel,
    Sp360DataTable,
    Sp360List,
  },

  data () {
    return {
      cards: {
        total_admissao: 0,
        total_aposentadoria: 0,
        total_vacancia: 0,
        ano: 0,
      },
      historicoAdmVac: {
        data: {},
        options: {},
      },
      historicoAdmVacRaca: {
        data: {},
        options: {},
      },
      valueAdmVacLinhaHistoricoRaca: 'Admissão',
      valueAdmAposentVacOrdenacao: 'Admissão',
      listaTipoOrdenacao: ['Admissão', 'Aposentadoria', 'Exoneração'],
      tipoOrdenacao: { 'Admissão': 0, 'Aposentadoria': 1, 'Exoneração': 2 },
      tipoSexo: { 'Todos': 'dados', 'Feminino': 'dadosFemininos', 'Masculino': 'dadosMasculinos' },
      valueAdmAposentVacData: 0,
      listaDataFiltro: [],
      listaOrgaos: [],
      dataMaisRecente: 0,
      valueAdmVacLinhaHistoricoRacaSexo: 'Todos',
      listaTipoSexo: ['Todos', 'Masculino', 'Feminino'],

      datasetAdmAposentVac: [],
      admVacAposent: {
        data: {},
        options: {},
      },
      camposFaixaEtaria: ['X0_17', 'X18_24', 'X25_34', 'X35_44', 'X45_54', 'X55_64', 'X65_74', 'X75_mais'],
      faixaEtaria: {
        data: {},
        options: {},
      },
      datasetFaixaEtaria: [],

      racaSexo: {
        data: {},
        options: {},
      },
      datasetRacaSexo: [],
      datasetAdmVacRaca: [],
      valueAdmAposentVacOrdenacaoCaracteristica: 'Admissão',
      valueAdmAposentVacSecretariaCaracteristica: 'SÃO PAULO',
      valueAdmAposentVacDataCaracteristica: 0,
    }
  },

  computed: {

  },

  created () {
    const dataInicioDatasets = Constantes.PARAMETROS_DASHBOARD.FOLHA_PAGAMENTO.HISTORICO_SERVIDORES.HISTORICO_ADMISSAO_VACANCIA_DATA_INICIO_DATASETS
    const numeroValoresEixoX = Constantes.PARAMETROS_DASHBOARD.FOLHA_PAGAMENTO.HISTORICO_SERVIDORES.HISTORICO_ADMISSAO_VACANCIA_TAXA_TAMANHO_GRAFICO
    const anoCorrente = new Date().getFullYear()
    let histAdmAposentVacDataInicio = anoCorrente - (Math.round(Number((anoCorrente - dataInicioDatasets) * 3 / 4)))
    Promise.all([
      this.$store.dispatch('funcionalismo/buscarHistoricoAdmissoesVacanciasDosServidores', {}),
      this.$store.dispatch('funcionalismo/buscarHistoricoAdmissoesDosServidoresNoIntervalo', { dataInicio: dataInicioDatasets }),
      this.$store.dispatch('funcionalismo/buscarHistoricoVacanciasDosServidoresNoIntervalo', { agrupamento: 'secretaria', dataInicio: dataInicioDatasets }),
      this.$store.dispatch('funcionalismo/buscarHistoricoAposentadoriasDosServidoresNoIntervalo', { dataInicio: dataInicioDatasets }),
      this.$store.dispatch('funcionalismo/buscarHistoricoServidoresPorCaracteristicasNoIntervalo', { dataReferencia: 'admissao', agrupamento: 'secretaria,faixa_etaria,sexo', dataInicio: dataInicioDatasets }),
      this.$store.dispatch('funcionalismo/buscarHistoricoServidoresPorCaracteristicasNoIntervalo', { dataReferencia: 'aposentadoria', agrupamento: 'secretaria,faixa_etaria,sexo', dataInicio: dataInicioDatasets }),
      this.$store.dispatch('funcionalismo/buscarHistoricoServidoresPorCaracteristicasNoIntervalo', { dataReferencia: 'vacancia', agrupamento: 'secretaria,faixa_etaria,sexo', dataInicio: dataInicioDatasets }),
      this.$store.dispatch('funcionalismo/buscarHistoricoServidoresPorCaracteristicasNoIntervalo', { dataReferencia: 'admissao', agrupamento: 'raca,sexo,secretaria', dataInicio: dataInicioDatasets }),
      this.$store.dispatch('funcionalismo/buscarHistoricoServidoresPorCaracteristicasNoIntervalo', { dataReferencia: 'aposentadoria', agrupamento: 'raca,sexo,secretaria', dataInicio: dataInicioDatasets }),
      this.$store.dispatch('funcionalismo/buscarHistoricoServidoresPorCaracteristicasNoIntervalo', { dataReferencia: 'vacancia', agrupamento: 'raca,sexo,secretaria', dataInicio: dataInicioDatasets }),
      this.$store.dispatch('funcionalismo/buscarHistoricoAdmissoesVacanciasDosServidoresPorRaca', { dataInicio: histAdmAposentVacDataInicio }),
    ]).then(respostas => {

      //{fonte: fonte, data: dataRef}
      //:footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})"
      this.fonte = respostas[0].data.sigla_orgao + '-' + respostas[0].data.fonte
      this.dataRef = new Date(respostas[0].data.data_referencia_dado).toLocaleDateString('pt-BR')
      this.ref = this.$t('rodape.fonteData', { fonte: this.fonte, data: this.dataRef })


      this.cores = CorUtils.getVetorCoresPorTom('claro').slice(7)

      this.cards = this.populateCards(respostas[0].data.data)

      this.historicoAdmVac.options = this.getLineChartOptions(' ', this.$t('funcionalismo.historico-servidores.graficos.eixoY-numero-servidores'))
      let total = respostas[0].data.data.length

      this.historicoAdmVac.data = this.populateHistoricoAdmVac(respostas[0].data.data.slice(total * numeroValoresEixoX, total), this.cores, this.$store.getters.palette.transparent)

      this.admVacAposent.options = this.getBarChartOptions(' ', this.$t('funcionalismo.historico-servidores.graficos.eixoY-numero-servidores'), 'logarithmic')

      this.datasetAdmAposentVac = [{ nome: 'Admissão', dados: respostas[1].data.data },
        { nome: 'Aposentadoria', dados: respostas[3].data.data },
        { nome: 'Exoneração', dados: respostas[2].data.data }]

      this.dataMaisRecente = _.maxBy(respostas[1].data.data, 'ano').ano
      this.listaDataFiltro = MethGlob.range(1990, this.dataMaisRecente).sort(function (a, b) { return b - a }),
      this.valueAdmAposentVacData = this.dataMaisRecente

      this.carregarListaOrgaos(_.orderBy(respostas[4].data.data, 'secretaria'))
      this.admVacAposent.data = this.populateAdmAposentVac(_.cloneDeep(this.datasetAdmAposentVac), this.dataMaisRecente, this.datasetAdmAposentVac[0].nome)

      this.datasetFaixaEtaria = [{ nome: 'Admissão', dados: respostas[4].data.data },
        { nome: 'Aposentadoria', dados: respostas[5].data.data },
        { nome: 'Exoneração', dados: respostas[6].data.data }]

      this.datasetRacaSexo = [{ nome: 'Admissão', dados: respostas[7].data.data },
        { nome: 'Aposentadoria', dados: respostas[8].data.data },
        { nome: 'Exoneração', dados: respostas[9].data.data }]

      this.valueAdmAposentVacDataCaracteristica = this.dataMaisRecente
      this.atualizarGraficosRacaSexoEFaixaEtaria(this.dataMaisRecente, 'Admissão', 'SÃO PAULO')

      this.datasetAdmVacRaca = [{ nome: 'Admissão', dados: _.orderBy(respostas[10].data.data.filter(x => x.tipo == 'admissao'), ['ano', 'total'], ['asc', 'desc']), dadosFemininos: {}, dadosMasculinos: {} },
        { nome: 'Aposentadoria', dados: _.orderBy(respostas[10].data.data.filter(x => x.tipo == 'aposentadoria'), ['ano', 'total'], ['asc', 'desc']), dadosFemininos: {}, dadosMasculinos: {} },
        { nome: 'Exoneração', dados: _.orderBy(respostas[10].data.data.filter(x => x.tipo == 'vacancia'), ['ano', 'total'], ['asc', 'desc']), dadosFemininos: {}, dadosMasculinos: {} }]

      this.datasetAdmVacRaca.forEach(corte => {
        corte.dadosFemininos = corte.dados.filter(x => x.sexo == 'F')
        corte.dadosMasculinos = corte.dados.filter(x => x.sexo == 'M')
        corte.dados = MethGlob.multipleGroupAndSum(corte.dados, ['ano', 'tipo', 'raca'], ['total'])
      })

      this.atualizarGraficoLinhaHistoricoRaca('Admissão')
    })
  },

  methods: {
    rodapeData (d, data) {
      return MethGlob.rodapeData(d, data)
    },
    getLineChartOptions (legendaX, legendaY, percentual = true, milhar = true) {
      return {
        tooltips: {
          mode: 'index',
          intersect: true,
        },
        layout: {
          padding: {
            left: 0,
            right: 20,
            top: 15,
            bottom: 0,
          },
        },
        scales: {
          xAxes: [{
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.$t(legendaX || 'LegendaX'),
            },
          }],
          yAxes: [{
            ticks: {
              callback: (value) => MethGlob.thousandSeparator(value),
            },
            id: 'y-axis-1',
            type: 'linear',
            position: 'left',
            display: 'auto',
            scaleLabel: {
              display: true,
              labelString: this.$t(legendaY || 'LegendaY'),
            },
          }],
        },
        plugins: {
          datalabels: {
            clamp: true,
            font: {
              // size: 16,
            },
            labels: {
              value: {
                font: {
                  weight: 'bold',
                },
              },
            },
            anchor: 'start',
            align: 'end',
            formatter: function (value, context) {
              return MethGlob.thousandSeparator(value)
            },
            color: '#000',
            display: 'auto',
          },
        },
      }
    },
    populateHistoricoAdmVac (dados, backgroundColor, borderColor) {
      let chartData = { labels: [], datasets: [] }
      let nomeDados = [{ nome: 'Admissões', campo: 'total_admissao' },
        { nome: 'Aposentadorias', campo: 'total_aposentadoria' },
        { nome: 'Exoneração', campo: 'total_vacancia' }]
      let vetorCores = CorUtils.getVetorCoresPorTom('medio')
      for (const nomeDado of nomeDados) {
        let cor = vetorCores.shift()
        let dataset = {
          data: [],
          label: nomeDado.nome,
          backgroundColor: cor || backgroundColor,
          borderColor: cor || borderColor,
          fill: false,
          spanGaps: true,
        }
        for (const dado of dados) {
          if (!isNaN(dado[nomeDado.campo]) && Number(dado[nomeDado.campo]) > 0) {
            dataset.data.push(Number(dado[nomeDado.campo]))
          } else {
            dataset.data.push(null)
          }
          if (nomeDado.nome == 'Admissões') { chartData.labels.push(dado.ano) }
        }
        chartData.datasets.push(dataset)
      }
      return chartData
    },
    populateCards (dadosHistoricosAdmVac) {
      let cards = {}
      cards.total_admissao = dadosHistoricosAdmVac[dadosHistoricosAdmVac.length - 1].total_admissao
      cards.total_aposentadoria = dadosHistoricosAdmVac[dadosHistoricosAdmVac.length - 1].total_aposentadoria
      cards.total_vacancia = dadosHistoricosAdmVac[dadosHistoricosAdmVac.length - 1].total_vacancia
      cards.ano = dadosHistoricosAdmVac[dadosHistoricosAdmVac.length - 1].ano
      return cards
    },
    getBarChartOptions (xAxixLabel, yAxixLabel, tipo = 'linear', titulo = '') {
      return {
        title: {
          display: !(titulo == null || titulo == 'undefined' || titulo == ''),
          text: titulo,
        },
        layout: {
          padding: {
            left: 20,
            right: 20,
            top: 25,
            bottom: 5,
          },
        },
        plugins: {
          datalabels: {
          },
        },
        tooltips: {
          mode: 'index',
          enabled: true,
          intersect: true,
          callbacks: {
            title: function (tooltipItems, data) {
              var title = ''
              var labels = data.labels
              var labelCount = labels ? labels.length : 0

              if (tooltipItems.length > 0) {
                var item = tooltipItems[0]
                if (item.label) {
                  title = item.label
                } else if (item.xLabel) {
                  title = item.xLabel
                } else if (labelCount > 0 && item.index < labelCount) {
                  title = labels[item.index]
                }
              }
              return title
            },
            label: function (tooltipItem, details) {
              let dataset = details.datasets[tooltipItem.datasetIndex]
              let currentValue = dataset.data[tooltipItem.index]
              return dataset.label ? dataset.label + ': ' + currentValue.toLocaleString('pt-BR') : currentValue.toLocaleString('pt-BR')
            },
          },
        },
        responsive: true,
        legend: {
          position: 'bottom',
          display: true,
          labels: {
            fontColor: '#34495e',
            fontFamily: 'sans-serif',
            fontSize: 14,
            padding: 20,
            usePointStyle: true,
          },
        },
        scales: {
          yAxes: [{
            categoryPercentage: 0.2,
            barPercentage: 1.0,
            type: tipo,

            scaleLabel: {
              display: true,
              labelString: yAxixLabel,
            },
            ticks: {
              beginAtZero: true,
              autoSkip: true,
              maxTicksLimit: 15,
              callback: function (value, index, values) {
                if (!isNaN(value)) {
                  return MethGlob.formatarGrandesNumeros(value)
                } else {
                  return value
                }
              },
            },
          }],
          xAxes: [
            {
              position: 'left',
              gridLines: {
                display: false,
              },
              scaleLabel: {
                display: true,
                labelString: xAxixLabel,
              },
              ticks: {
                callback: function (value, index, values) {
                  return value
                },
              },
            },
          ],
        },
      }
    },
    getBarChartPiramideOptions (xAxixLabel, yAxixLabel, tipo = 'linear', titulo = '') {
      return {
        title: {
          display: (titulo != null && titulo != 'undefined' && titulo != ''),
          text: titulo,
        },
        layout: {
          padding: {
            left: 20,
            right: 20,
            top: 25,
            bottom: 5,
          },
        },
        plugins: {
          datalabels: {
            clamp: true,
            anchor: 'center',
            align: 'end',
            formatter: function (value, context) {
              return MethGlob.thousandSeparator(value)
            },
            color: '#000',
            display: 'auto',
          },
        },
        tooltips: {
          mode: 'index',
          enabled: true,
          intersect: true,
          callbacks: {
            title: function (tooltipItems, data) {
              var title = ''
              var labels = data.labels
              var labelCount = labels ? labels.length : 0

              if (tooltipItems.length > 0) {
                var item = tooltipItems[0]
                if (item.label) {
                  title = item.label
                } else if (item.xLabel) {
                  title = item.xLabel
                } else if (labelCount > 0 && item.index < labelCount) {
                  title = labels[item.index]
                }
              }
              return title
            },
            label: function (tooltipItem, details) {
              let dataset = details.datasets[tooltipItem.datasetIndex]
              let currentValue = dataset.data[tooltipItem.index]
              currentValue = currentValue < 0 ? -currentValue : currentValue
              return dataset.label ? dataset.label + ': ' + currentValue.toLocaleString('pt-BR') : currentValue.toLocaleString('pt-BR')
            },
          },
        },
        responsive: true,
        legend: {
          position: 'bottom',
          display: true,
          labels: {
            fontColor: '#34495e',
            fontFamily: 'sans-serif',
            fontSize: 14,
            padding: 20,
            usePointStyle: true,
          },
        },
        scales: {
          offset: true,
          yAxes: [{
            stacked: true,
            barPercentage: 1.1,

            scaleLabel: {
              display: true,
              labelString: yAxixLabel,
            },
            ticks: {
              beginAtZero: true,
              autoSkip: true,
              maxTicksLimit: 15,
              padding: 25,
              callback: function (value, index, values) {
                if (!isNaN(value)) {
                  return MethGlob.formatarGrandesNumeros(value)
                } else {
                  return value
                }
              },
            },
          }],
          xAxes: [
            {
              stacked: false,
              type: 'linear',
              gridLines: {
                display: false,
              },
              scaleLabel: {
                display: true,
                labelString: xAxixLabel,
              },
              ticks: {
                beginAtZero: true,
                callback: function (value, index, values) {
                  return MethGlob.formatarGrandesNumeros(value < 0 ? -value : value)
                },
              },
            },
          ],
        },
      }
    },
    populateAdmAposentVac (dados, dataParaMostrar, ordenacao = 'Admissão') {
      const tam = Constantes.PARAMETROS_DASHBOARD.FOLHA_PAGAMENTO.HISTORICO_SERVIDORES.HISTORICO_ADMISSAO_APOSENTADORIA_VACANCIA_BARCHART_TAM
      const tipoOrdenacao = this.tipoOrdenacao
      dados.forEach(d => {
        d.dados = d.dados.filter(x => x.ano == dataParaMostrar)
        d.dados = _.orderBy(d.dados, 'total', 'desc')
      })
      dados[tipoOrdenacao[ordenacao]].dados = dados[tipoOrdenacao[ordenacao]].dados.slice(0, tam)

      let backgroundColor = CorUtils.getVetorCoresPorTom('claro').slice(6)
      let chartData = { labels: [], datasets: [] }

      dados[tipoOrdenacao[ordenacao]].dados.forEach(element => {
        if (chartData.labels.indexOf(element['secretaria']) == -1) { chartData.labels.push(element['secretaria']) }
      })

      for (let d in dados) {
        let cor = backgroundColor.shift()
        let dataset = {
          data: new Array(tam).fill(0),
          label: '',
          backgroundColor: cor,
          borderColor: cor,
          fill: false,
          datalabels: {
            color: CorUtils.getCorPorNomeSp360('preto-escuro'),
            formatter: (value) => value.toLocaleString('pt-BR'),
            anchor: 'start',
            rotation: -90,
            align: 'end',
            labels: {
              value: {
                font: {
                  weight: 'bold',
                },
              },
            },
          },
        }

        dados[d].dados.forEach(element => {
          let posicao = chartData.labels.indexOf(element['secretaria'])
          if (posicao != -1) { dataset.data[posicao] = Number(element['total']) }
        })

        dataset.label = dados[d].nome
        chartData.datasets.push(dataset)
      }
      return chartData
    },
    atualizarGraficosRacaSexoEFaixaEtaria (dataParaMostrar, tipoCorte = 'Admissão', filtroSecretaria) {
      let tipoOrdenacao = this.tipoOrdenacao
      let amostragemRacaSexo = this.datasetRacaSexo[tipoOrdenacao[tipoCorte]].dados.filter(x => x.ano == dataParaMostrar)
      let amostragemFaixaEtaria = this.datasetFaixaEtaria[tipoOrdenacao[tipoCorte]].dados.filter(x => x.ano == dataParaMostrar)
      let agrupamento = []
      let amostragemFaixaEtariaVazia = [{ X0_17: 0, X18_24: 0, X25_34: 0, X35_44: 0, X45_54: 0, X55_64: 0, X65_74: 0, X75_mais: 0, ano: dataParaMostrar, secretaria: filtroSecretaria }]

      if (filtroSecretaria != 'SÃO PAULO') {
        amostragemRacaSexo = amostragemRacaSexo.filter(x => x.secretaria == filtroSecretaria)
        amostragemFaixaEtaria = amostragemFaixaEtaria.filter(x => x.secretaria == filtroSecretaria)
      } else {
        amostragemRacaSexo = MethGlob.multipleGroupAndSum(amostragemRacaSexo, ['ano', 'raca', 'sexo'], ['total'])
        amostragemFaixaEtaria = MethGlob.multipleGroupAndSum(amostragemFaixaEtaria, ['ano', 'sexo'],
          ['X0_17', 'X18_24', 'X25_34', 'X35_44', 'X45_54', 'X55_64', 'X65_74', 'X75_mais', 'total'])
      }

      amostragemFaixaEtaria = amostragemFaixaEtaria.length ? amostragemFaixaEtaria : amostragemFaixaEtariaVazia

      this.racaSexo.options = this.getBarChartOptions(' ', this.$t('funcionalismo.historico-servidores.graficos.eixoY-numero-servidores'), 'linear', `Amostragem de Servidores por Raça e Sexo`)
      this.racaSexo.data = this.populateAdmAposentVacRacaSexo(amostragemRacaSexo)

      this.faixaEtaria.options = this.getBarChartPiramideOptions(this.$t('funcionalismo.historico-servidores.graficos.eixoY-numero-servidores'), '', 'linear', `Amostragem de Servidores por Faixa Etária`)
      this.faixaEtaria.data = this.populateAdmAposentVacFaixaEtaria(amostragemFaixaEtaria)
    },
    populateAdmAposentVacRacaSexo (dadosFiltrados) {
      let backgroundColor = CorUtils.getVetorCoresPorTom('claro').slice(6)
      let chartData = { labels: [], datasets: [] }
      let ordemSexo = []
      dadosFiltrados = _.orderBy(dadosFiltrados, 'total', 'desc')

      dadosFiltrados.forEach(element => {
        if (chartData.labels.indexOf(element['raca']) == -1) { chartData.labels.push(element['raca']) }

        if (ordemSexo.indexOf(element['sexo']) == -1) { ordemSexo.push(element['sexo']) }
      })

      for (let sexo of ordemSexo) {
        let cor = backgroundColor.shift()
        let dataset = {
          data: new Array(chartData.labels.length).fill(0),
          label: '',
          backgroundColor: cor,
          borderColor: cor,
          fill: false,
          datalabels: {
            color: CorUtils.getCorPorNomeSp360('preto-escuro'),
            formatter: (value) => value.toLocaleString('pt-BR'),
            anchor: 'start',
            rotation: -90,
            align: 'end',
            labels: {
              value: {
                font: {
                  weight: 'bold',
                },
              },
            },
          },
        }
        let mapeamentoSexo = { F: 'Feminino', M: 'Masculino' }
        dadosFiltrados.forEach(element => {
          if (element['sexo'] == sexo) {
            let posicao = chartData.labels.indexOf(element['raca'])
            if (posicao != -1) { dataset.data[posicao] = Number(element['total']) }
          }
        })
        dataset.label = mapeamentoSexo[sexo]
        chartData.datasets.push(dataset)
      }
      return chartData
    },

    populateAdmAposentVacFaixaEtaria (dadosFiltrados) {
      let backgroundColor = CorUtils.getVetorCoresPorTom('claro').slice(6)
      let chartData = { labels: [], datasets: [] }

      chartData.labels = this.camposFaixaEtaria

      let corFem = backgroundColor.shift()
      let corMasc = backgroundColor.shift()

      dadosFiltrados.forEach(datasetPorSexo => {
        let dataset = {
          data: new Array(chartData.labels.length).fill(0),
          label: datasetPorSexo.sexo === 'M' ? 'Masculino' : 'Feminino',
          backgroundColor: datasetPorSexo.sexo === 'M' ? corMasc : corFem,
          stack: 'Stack 0',
          borderColor: datasetPorSexo.sexo === 'M' ? corMasc : corFem,
          fill: false,
          datalabels: {
            color: CorUtils.getCorPorNomeSp360('preto-escuro'),
            formatter: (value) => {
              value = value < 0 ? -value : value
              value = value === 0 ? 0 : value
              return value.toLocaleString('pt-BR')
            },
            anchor: datasetPorSexo.sexo === 'M' ? 'start' : 'end',
            rotation: 0,
            align: datasetPorSexo.sexo === 'M' ? 'start' : 'end',
            offset: 1,
            labels: {
              value: {
                font: {
                  weight: 'bold',
                },
              },
            },
          },
        }

        chartData.labels.forEach(element => {
          let posicao = chartData.labels.indexOf(element)
          if (posicao != -1) { dataset.data[posicao] = Number(datasetPorSexo[element]) }
        })
        if (dataset.label === 'Masculino') {
          dataset.data = dataset.data.map((k) => -k)
        }

        chartData.datasets.push(dataset)
      })

      chartData.labels = chartData.labels.map(label => this.getLabelFaixa(label))

      return chartData
    },
    carregarListaOrgaos (dados) {
      this.listaOrgaos.push('SÃO PAULO')
      dados.forEach(orgao => {
        if (this.listaOrgaos.indexOf(orgao['secretaria']) == -1) { this.listaOrgaos.push(orgao['secretaria']) }
      })
    },
    getLabelFaixa (faixa) {
      let aux = faixa.split('_')
      let min = aux[0].replace('X', '')
      return 'De ' + min + ' a ' + aux[1] + ' anos'
    },
    multiselectAdmAPosentVacOrdenacao (value) {
      if (value != undefined) {
        this.admVacAposent.options = this.getBarChartOptions(' ', this.$t('funcionalismo.historico-servidores.graficos.eixoY-numero-servidores'))
        this.admVacAposent.data = this.populateAdmAposentVac(_.cloneDeep(this.datasetAdmAposentVac), this.valueAdmAposentVacData, value)
      } else {
        this.valueAdmAposentVacOrdenacao = 'Admissão'
        this.admVacAposent.options = this.getBarChartOptions(' ', this.$t('funcionalismo.historico-servidores.graficos.eixoY-numero-servidores'))
        this.admVacAposent.data = this.populateAdmAposentVac(_.cloneDeep(this.datasetAdmAposentVac), this.valueAdmAposentVacData, value)
      }
    },
    multiselectAdmAposentVacData (value) {
      if (value != undefined) {
        this.admVacAposent.options = this.getBarChartOptions(' ', this.$t('funcionalismo.historico-servidores.graficos.eixoY-numero-servidores'))
        this.admVacAposent.data = this.populateAdmAposentVac(_.cloneDeep(this.datasetAdmAposentVac), value, this.valueAdmAposentVacOrdenacao)
      } else {
        this.valueAdmAposentVacData = this.dataMaisRecente
        this.admVacAposent.options = this.getBarChartOptions(' ', this.$t('funcionalismo.historico-servidores.graficos.eixoY-numero-servidores'))
        this.admVacAposent.data = this.populateAdmAposentVac(_.cloneDeep(this.datasetAdmAposentVac), value, this.valueAdmAposentVacOrdenacao)
      }
    },
    multiselectAdmAposentVacOrdenacaoCaracteristica (value) {
      this.atualizarGraficosRacaSexoEFaixaEtaria(this.valueAdmAposentVacDataCaracteristica, value, this.valueAdmAposentVacSecretariaCaracteristica)
    },
    multiselectAdmAposentVacSecretariaCaracteristica (value) {
      this.atualizarGraficosRacaSexoEFaixaEtaria(this.valueAdmAposentVacDataCaracteristica, this.valueAdmAposentVacOrdenacaoCaracteristica, value)
    },
    multiselectAdmAposentVacDataCaracteristica (value) {
      this.atualizarGraficosRacaSexoEFaixaEtaria(value, this.valueAdmAposentVacOrdenacaoCaracteristica, this.valueAdmAposentVacSecretariaCaracteristica)
    },
    multiselectAdmVacHistoricoRaca (value) {
      this.atualizarGraficoLinhaHistoricoRaca(value, this.valueAdmVacLinhaHistoricoRacaSexo)
    },
    multiselectAdmVacHistoricoRacaSexo (value) {
      this.atualizarGraficoLinhaHistoricoRaca(this.valueAdmVacLinhaHistoricoRaca, value)
    },
    atualizarGraficoLinhaHistoricoRaca (tipoCorte = 'Admissão', filtroSexo = 'Todos') {
      let tipoOrdenacao = this.tipoOrdenacao
      let tipoSexo = this.tipoSexo
      let amostragemCorte = this.datasetAdmVacRaca[tipoOrdenacao[tipoCorte]][tipoSexo[filtroSexo]]

      this.historicoAdmVacRaca.options = this.getLineChartOptions(' ', this.$t('funcionalismo.historico-servidores.graficos.eixoY-numero-servidores'))
      this.historicoAdmVacRaca.data = this.populateHistoricoAdmVacRaca(amostragemCorte, this.cores, this.$store.getters.palette.transparent)
    },
    populateHistoricoAdmVacRaca (dados, backgroundColor, borderColor) {
      let vetorCores = CorUtils.getVetorCoresPorTom('medio')
      return MethGlob.flatArrayToLineChartDatasets(dados, 'ano', 'raca', 'total', vetorCores)
    },

  },
}
</script>

<style lang='scss' scoped>
    .bubble{
        height:30rem;
        width:100%;
    }
    #admissaoAPosentadoriaVac{
        height:35rem
    }
    #faixaEtaria{
      height:30rem
    }
    #racaSexo {
      height:30rem
    }
    #historicoAdmissaoAposentadoriaVac{
        height:30rem
    }
    #historicoAdmissaoAposentadoriaVacHistRaca{
        height:30rem
    }
    #legenddiv {
        max-height: 10rem;
    }
    #faixaEtaria{
      box-shadow: none;
      align-self: center;
    }
    ::v-deep .red{
      background-color: #40e583;
    }
    #lista{
      max-height:  35rem;
      overflow-y: scroll;
    }
    #lista::-webkit-scrollbar {
        width: 12px;
    }
    #lista::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.1);
        border-radius: 10px;
    }
    #lista::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.2);
    }
    #tabelaOrgao{
      padding:0;
    }
    .toprow{
      max-height: 30rem
    }

</style>
